import styled from "styled-components";

// table
const Table = styled.table`
    border-collapse: collapse;
    border: 0;
    width: 100%;
`

export default Table